import { render, staticRenderFns } from "./GigApplicationStatusBadge.htm?vue&type=template&id=137d1aac&"
import script from "./GigApplicationStatusBadge.ts?vue&type=script&lang=js&"
export * from "./GigApplicationStatusBadge.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports